import { withPageAuthRequired } from "@auth0/nextjs-auth0/client";
import { useRouter } from "next/router";
import { useUser } from "contexts/user";

const PageHome = () => {
  const router = useRouter();
  const { role } = useUser();

  if(!role) {
    return null;
  }

  let route = "/dashboard";

  if(role.isDoctor) {
    route = "/exams";
  }
  if(role.isMedRecSpec) {
    route = "/incidents/record-breakdown";
  }
  if(role.isReceptionist) {
    route = "/appointments";
  }

  router.push(route);

  return null;
};

export default withPageAuthRequired(PageHome);
